module.exports = __webpack_public_path__ + "img/azurit.4ca4b20c.jpg";